// extracted by mini-css-extract-plugin
export default {"grid":"ProductItems_grid__DNr9N","single":"ProductItems_single__hGQ1Z","double":"ProductItems_double__0QCUU","list":"ProductItems_list__3YOra"};